/* HAND-AUTHORED (the artifact pipeline was unavailable for this stage) — stage "x-federation".
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. */

import type { NodeDef } from '../../types';

export const N_X_FEDERATION: NodeDef = {
  "id": "x-federation",
  "tagKey": "path:x-federation.tag",
  "x": 376,
  "y": 440,
  "w": 176,
  "h": 88,
  "titleKey": "path:x-federation.title",
  "subKey": "path:x-federation.sub",
  "blocks": [
    {
      "id": "x-federation.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:x-federation.b1.title",
      "bodyKey": "path:x-federation.b1.body",
      "flowKey": "path:x-federation.b1.flow",
      "read": [
        "mfe"
      ]
    },
    {
      "id": "x-federation.b2",
      "kind": "tree",
      "xp": 25,
      "titleKey": "path:x-federation.b2.title",
      "tree": {
        "qKey": "path:x-federation.b2.tree.q",
        "branches": [
          {
            "tone": "pass",
            "aKey": "path:x-federation.b2.tree.b.0.a",
            "verdictKey": "path:x-federation.b2.tree.b.0.verdict"
          },
          {
            "tone": "warn",
            "aKey": "path:x-federation.b2.tree.b.1.a",
            "verdictKey": "path:x-federation.b2.tree.b.1.verdict"
          },
          {
            "tone": "stop",
            "aKey": "path:x-federation.b2.tree.b.2.a",
            "verdictKey": "path:x-federation.b2.tree.b.2.verdict"
          },
          {
            "tone": "warn",
            "aKey": "path:x-federation.b2.tree.b.3.a",
            "verdictKey": "path:x-federation.b2.tree.b.3.verdict"
          }
        ]
      }
    },
    {
      "id": "x-federation.b3",
      "kind": "check",
      "xp": 30,
      "titleKey": "path:x-federation.b3.title",
      "ex": {
        "type": "choice",
        "options": [
          {
            "tKey": "path:x-federation.b3.ex.options.0.t",
            "ok": true,
            "fbKey": "path:x-federation.b3.ex.options.0.fb"
          },
          {
            "tKey": "path:x-federation.b3.ex.options.1.t",
            "ok": false,
            "fbKey": "path:x-federation.b3.ex.options.1.fb"
          },
          {
            "tKey": "path:x-federation.b3.ex.options.2.t",
            "ok": false,
            "fbKey": "path:x-federation.b3.ex.options.2.fb"
          },
          {
            "tKey": "path:x-federation.b3.ex.options.3.t",
            "ok": false,
            "fbKey": "path:x-federation.b3.ex.options.3.fb"
          }
        ]
      }
    }
  ],
  "extra": true,
  "parent": "frontend-composition"
};